import React from "react";

import { CustomCalendar } from "components/CustomCalendar/CustomCalendar";

import styles from "./DatePickerField.module.css";

export const DatePickerField = ({ value, onChange, label, placeholder = "Select date", disabled = false, maxDate = null, minDate = null }) => {
  const handleChange = (date) => {
    if (!date) {
      onChange?.("");
      return;
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    onChange?.(`${year}-${month}-${day}`);
  };

  return (
    <div className={styles.wrapper}>
      {label && <label className={styles.label}>{label}</label>}
      <CustomCalendar
        value={value || null}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={disabled}
        maxDate={maxDate}
        minDate={minDate}
      />
    </div>
  );
};
